import dayjs from 'dayjs';

// When a chat last spoke, as Telegram's list shows it: the time today,
// "Yesterday", the weekday within a week, then the date.
export const chatListTime = (time: number, yesterday = 'Yesterday') => {
  if (!time) {
    return '';
  }
  const day = dayjs(time);
  const now = dayjs();
  if (day.isSame(now, 'day')) {
    return day.format('HH:mm');
  }
  if (day.isSame(now.subtract(1, 'day'), 'day')) {
    return yesterday;
  }
  if (now.diff(day, 'day') < 7) {
    return day.format('ddd');
  }
  return day.format(day.isSame(now, 'year') ? 'D MMM' : 'D MMM YYYY');
};

// Unread counts past 99 read as "99+".
export const unreadLabel = (count: number) => (count > 99 ? '99+' : String(count));
